import { render, staticRenderFns } from "./TabGroup.vue?vue&type=template&id=56d36318&scoped=true"
import script from "./TabGroup.vue?vue&type=script&lang=ts"
export * from "./TabGroup.vue?vue&type=script&lang=ts"
import style0 from "./TabGroup.vue?vue&type=style&index=0&id=56d36318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d36318",
  null
  
)

export default component.exports